import React from 'react';
import Container from 'react-bootstrap/Container';

const Main = () => {
  return (
    <>
    <div className='contact-sec-bg-banner'>
        <Container >
            <div className='contactus-sec-text-div'>
                <h1 className='contactus-sec-text'>CONTACT US</h1>
            </div>
        </Container>
    </div>
    </>
  );
};

export default Main